var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewWindow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1666 25.3333H23.2499V33.6666H0.333252V10.7499H8.66659V12.8333H2.41659V31.5833H21.1666V25.3333ZM33.6666 0.333252V23.2499H10.7499V0.333252H33.6666ZM31.5833 2.41659H12.8333V21.1666H31.5833V2.41659ZM21.1666 16.9999H23.2499V12.8333H27.4166V10.7499H23.2499V6.58325H21.1666V10.7499H16.9999V12.8333H21.1666V16.9999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewWindow);
export default __webpack_public_path__ + "static/media/newWindow.4176e3cc565bb126fb44cd018929e35e.svg";
export { ForwardRef as ReactComponent };